import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { DialogBottomUpComponent } from './dialog-bottom-up.component';

@Component({
  template: '',
})
export class DialogBottomUpBaseComponent {
  @Output() dialogClose = new EventEmitter();
  @ViewChild(DialogBottomUpComponent) dialogBottomUp!: DialogBottomUpComponent;
}
